import { format } from 'date-fns';

export const formatDate = (isoDate: string): string => {
  try {
    return format(new Date(isoDate), 'dd/MM/yy');
  } catch (error) {
    console.error('Invalid date format:', error);
    return isoDate;
  }
};
